import { render, staticRenderFns } from "./BonCharge.vue?vue&type=template&id=8814cac8&"
import script from "./BonCharge.vue?vue&type=script&lang=js&"
export * from "./BonCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports